module.exports = __webpack_public_path__ + "706450d7bba6374ca02fe167d86685cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/ui/dist/fonts/fontawesome-webfont.ttf?v=4.3.0
// module id = 480
// module chunks = 0